// Core Angular
import angular from 'angular';
import angularPl from './angular-pl';
import ngSanitizeModuleName from 'angular-sanitize';

// Libs
import angularTooltips from 'angular-tooltips';
import angularClickOutside from '@iamadamjowett/angular-click-outside';
import uiRouter from '@uirouter/angularjs';
import angularModalService from 'angular-modal-service';
import angularMaterial from 'angular-material';

// FE
import cartCountComponent from './cart/cartcount.component';
import cartDropdownComponent from './cart/cartdropdown.component';
import cartDropdownContentComponent from './cart/cartdropdowncontent.component';
import cartItemComponent from './cart/cartItem.component';
import cartItemService from './cart/cartItem.service';
import cartService from './cart/cart.service';
import priceTypeService from './price/priceType.service';
import priceTypeComponent from './price/priceType.component';
import translateFilter from './translate/translate.filter';
import translateService from './translate/translate.service';
import snackbarService from './checkout/snackbar.service';
import snackbarComponent from './checkout/snackbar.component';
import cookieWallComponent from './cookieWall/cookieWall.component';
import AutogrowDirective from './autogrow.directive';
import MaxCharsDirective from './configurator/maxChars.directive';
import CheckoutService from './checkout/checkout.service';

const dependencies = [
    ngSanitizeModuleName,
    uiRouter,
    angularTooltips,
    'angularModalService',
    'angular-click-outside',
    angularMaterial
];

let configuratorApp = angular.module('contra', dependencies)
    // FE
    .service('cartService', cartService)
    .component('cartCount', cartCountComponent)
    .component('cartDropdownContent', cartDropdownContentComponent)
    .component('cartDropdown', cartDropdownComponent)
    .component('cartItem', cartItemComponent)
    .service('cartItemService', cartItemService)
    .filter('t', translateFilter)
    .service('translateService', translateService)
    .component('priceType', priceTypeComponent)
    .service('priceTypeService', priceTypeService)
    .service('SnackbarService', snackbarService)
    .service('CheckoutService', CheckoutService)
    .component('snackbar', snackbarComponent)
    .component('cookieWall', cookieWallComponent)
    .directive('autogrow', AutogrowDirective.directiveFactory)
    .directive('maxChars', MaxCharsDirective.directiveFactory);

configuratorApp.config(['$locationProvider', function($locationProvider) {
    $locationProvider.html5Mode({
        enabled: true,
        rewriteLinks: false,
        requireBase: false
    });
}]);
